import { CSSProperties, FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyFieldContainer } from './empty-field.style';
import EmptyImg from './emptyField.svg';

const EmptyFieldTmp: FC<{ style?: CSSProperties; children?: ReactNode }> = ({ style, children }) => {
	const { t } = useTranslation('components', { keyPrefix: 'empty-field' });
	return (
		<EmptyFieldContainer style={style}>
			<div>
				<img src={EmptyImg} alt='' />
				<p>{t('notfound')}</p>
				{children && children}
			</div>
		</EmptyFieldContainer>
	);
};

export default EmptyFieldTmp;
